<template>
<ValidationObserver ref="observer">
  <form ref="edit_gate_pass_form" @submit.prevent="handleSubmit(updateGatePass)">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Client Master
        </h4>
      </md-card-header> -->
      <md-card-content>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="pool" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed</label>
                  <md-select v-model="gate_pass_pool_id" required>
                <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                  {{ option.pool_name }}
                </md-option> 
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.pko_pool"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="applicant" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Applicant</label>
                  <md-input v-model="gate_pass_applicant_name" required />
                  <validation-error
                    :errors="apiValidationErrors.gate_pass_applicant_name"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <label class="md-size-15 md-form-label">Start Date</label>
              <validation-provider rules="startdate" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-input type="date" v-model="gate_pass_start_date" required />
                  <validation-error
                    :errors="apiValidationErrors.gate_pass_start_date"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="purpose" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Purpose</label>
                  <md-input v-model="gate_pass_purpose" required />
                  <validation-error
                    :errors="apiValidationErrors.gate_pass_purpose"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="vehicle" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Vehicle</label>
                  <md-input placeholder="Search by using plate no" v-model="gate_pass_vehicle_plate_no" required />
                  <md-button :disabled="!gate_pass_vehicle_plate_no" class="md-icon-button md-round md-info md-dense" v-on:click="findVehiclePlatNo()"><md-icon >search</md-icon></md-button>
                  <validation-error
                    :errors="apiValidationErrors.gate_pass_vehicle_plate_no"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
          <div class="md-layout-item md-small-size-100" style="margin-top:15px;">
              <validation-provider rules="vin" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Vin No</label>
                  <md-input  v-model="gate_pass_vehicle_chassis_no" disabled required />
                  <validation-error
                    :errors="apiValidationErrors.gate_pass_vehicle_chassis_no"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        
        
      </md-card-content>
      

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
        <!-- <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button> -->
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

extend('applicant', {
  ...required,
  message: 'Applicant Field is required'
});

extend('startdate', {
  ...required,
  message: 'Start Date Field is required'
});

extend('purpose', {
  ...required,
  message: 'Purpose Field is required'
});

extend('vehicle', {
  ...required,
  message: 'Plate No Field is required'
});

extend('vin', {
  ...required,
  message: 'Vin No Field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    name: "edit-business-unit--test",
    
    props: {
      data_id:null,
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

   data: () => ({
      // business_unit: [],
      gate_pass_applicant_name: null,
      gate_pass_start_date: null,
      gate_pass_purpose: null,
      gate_pass_vehicle_plate_no : null,
      gate_pass_vehicle_chassis_no : null,
      options_pool_list: null
    }),

    created() {
      this.getGatePassData();
      this.getDataPool();
    },


    methods: {

      async getDataPool(){
        await this.$store.dispatch("workshop_pool/list")
        this.options_pool_list = await this.$store.getters["workshop_pool/list"];
      },
      
      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Gate Pass' })
    },

      // fungsi untuk mendapatkan data yang akan di edit dengan id yang dikirim bersamaan dengan route
      async getGatePassData(){
        //check apakah id ada di route
        if(this.data_id.id){
          
        //jika ada ambil data dari api
        await this.$store.dispatch("workshop_gate_pass/get", this.data_id.id)
        this.gate_pass = await this.$store.getters["workshop_gate_pass/gate_pass"]

        this.gate_pass_applicant_name = this.gate_pass.gate_pass_applicant_name
        this.gate_pass_start_date = this.gate_pass.gate_pass_start_date
        this.gate_pass_purpose = this.gate_pass.gate_pass_purpose
        this.gate_pass_vehicle_plate_no = this.gate_pass.gate_pass_vehicle.vehicle_plate_no
        this.gate_pass_vehicle_chassis_no = this.gate_pass.gate_pass_vehicle.vehicle_chassis_no
        this.gate_pass_pool_id = this.gate_pass.gate_pass_pool_id
        }
        else{
          //jika tidak ada kembali ke list
          await this.$router.replace({name: 'List Gate Pass'});
        }
      },

      setData(data){
      this.gate_pass_vehicle_id = data.id
      // this.checker.vehicle_plate_no = data.vehicle_plate_no
      this.gate_pass_vehicle_chassis_no = data.vehicle_engine_no
      this.dataValid = true

    },

    async findVehiclePlatNo(){
      var query = {}
      query.filter = {find_vehicle_plate_no:this.gate_pass_vehicle_plate_no}
      await this.$store.dispatch("workshop_vehicle/list", query)
       var data = await this.$store.getters["workshop_vehicle/list"];
      if(Object.keys(data).length!=0){
           this.setData(data[0])
       }
       else{
         this.swalFindError()
         this.dataValid = false
          this.gate_pass_vehicle_plate_no = null
       }
        //  this.swalFindError()
        //  this.dataValid = false
        //   this. checker.id = data.id
        //   this.checker.vehicle_plate_no = data.vehicle_plate_no
        //   this.checker.vehicle_door_no = data.vehicle_door_no
       
    },

    swalFindError(){
      this.gate_pass_vehicle_plate_no = null,
      this.gate_pass_vehicle_chassis_no = null
      Swal.fire({
          icon: 'error',
          title: 'Not Found',
          text: 'Data kendaraan tidak ditemukan',
        })
    },

      // validasi menggunakan sweetalert  sebelum mengubah data
      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateGatePass(id)
          }
        });
    },


    // fungsi edit
      async updateGatePass() {

        // if(this.$route.params.id == null || !this.$route.params.id) {
        //   await this.$store.dispatch("alerts/error", "error")
        //   return
        // }

        const data = {
          type: "workshop_gate_passes",
          id: this.gate_pass.id,
          gate_pass_applicant_name: this.gate_pass_applicant_name,
          gate_pass_start_date: this.gate_pass_start_date,
          gate_pass_purpose: this.gate_pass_purpose,
          gate_pass_vehicle_id: this.gate_pass_vehicle_id,
          gate_pass_pool_id : this.gate_pass_pool_id
        }

        try {
          //kirim data ke server
          await this.$store.dispatch("workshop_gate_pass/update", data)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "Gate Pass data changed successfully.")
          //kembali ke list
          // await this.$router.replace({name: 'List Gate Pass'});
          this.$parent.$parent.modalCloseEdit();
        } catch (e) {
          //panggil notifikasi error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      }
    }
  };
</script>
